import {request} from "@/shared/api/http";

interface DemoRequestBodyDTO {
    fullName: string;
    phone: string;
    uin: string;
}

export const requestDemo = async (body: DemoRequestBodyDTO) => {
    return (await request.post(`/proxy/ismet-docs-api.ismet-docs/api/v1/demo-request`, body)).data;
}